import React from 'react';
import { cn, formatDateTime } from '@/lib/utils';
import { User } from 'lucide-react';

export const ConversationPanel = ({ messages, className }) => {
  if (!messages || messages.length === 0) {
    return (
      <div className={cn('p-4 text-center text-slate-500 text-sm', className)}>
        Aucun message disponible
      </div>
    );
  }

  return (
    <div className={cn('space-y-3 p-4', className)}>
      {messages.map((message, index) => (
        <div
          key={message.id || index}
          className={cn(
            'flex gap-3',
            message.sender === 'host' ? 'flex-row-reverse' : ''
          )}
        >
          <div
            className={cn(
              'w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0',
              message.sender === 'host' ? 'bg-[#FF5A6E]' : 'bg-slate-300'
            )}
          >
            <User size={14} className="text-white" />
          </div>
          <div
            className={cn(
              'max-w-[75%] px-4 py-2.5 text-sm',
              message.sender === 'host'
                ? 'bg-[#FFF0F1] text-slate-800 rounded-2xl rounded-br-md'
                : 'bg-slate-100 text-slate-800 rounded-2xl rounded-bl-md'
            )}
          >
            <p>{message.content}</p>
            <p className="text-[10px] text-slate-400 mt-1">
              {formatDateTime(message.sent_at)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationPanel;
